import React from "react";

export default function TeamUserCard(props) {
  return (
    <div className="bg-white border border-[var(--border)] rounded-[var(--radius)] p-5 transition-all duration-300 hover:shadow-[var(--shadow)] hover:-translate-y-1 w-full md:w-[300px]">
      <div className="w-[60px] h-[60px] rounded-full bg-gradient-to-br from-[#a78bfa] to-[var(--brand)] flex items-center justify-center overflow-hidden mb-4">
        <img
          src={props.image}
          alt={props.name}
          className="w-full h-full object-cover"
          onError={(e) => {
            e.target.style.display = 'none';
            e.target.parentElement.innerHTML = `<span class="text-white font-bold text-lg">${props.name?.split(' ').map(n => n[0]).join('').slice(0, 2)}</span>`;
          }}
        />
      </div>
      <div className="font-bold text-base text-[var(--text)] mb-1">
        {props.name}
      </div>
      <div className="text-xs font-semibold text-[var(--brand)] uppercase tracking-wide mb-3">
        {props.job}
      </div>
      <div className="text-sm text-[var(--muted)] leading-relaxed line-clamp-4">
        {props.summary}
      </div>
    </div>
  );
}
